import { createContext, useContext } from "react";
import { publicSiteDomain, type PublicSiteDomain } from "@contracts/public-site";

const PublicSiteContext = createContext<PublicSiteDomain>("tashiraev.com");

export function PublicSiteProvider({ domain, children }: { domain?: PublicSiteDomain; children: React.ReactNode }) {
  const resolved = domain ?? publicSiteDomain(typeof window === "undefined" ? null : window.location.hostname);
  return <PublicSiteContext.Provider value={resolved}>{children}</PublicSiteContext.Provider>;
}

export function usePublicSite() {
  return useContext(PublicSiteContext);
}
